<template>
  <div class="scoreEvaluation">
    <div class="coupon-content">
      <div class="coupon-title">为课程评价</div>
      <div v-if="type != 2" class="m-t-20 m-b-20">
        <el-select filterable v-model="kcId" placeholder="请选择课程" clearable @change="kcChange">
          <el-option v-for="(item, index) in kcList" :key="index" :label="item.belongCourseTitleName"
            :value="item.belongCourseTitleId" />
        </el-select>
        <el-select class="m-l-20" filterable v-model="yeaster" placeholder="请选择年份" clearable @change="getclass">
          <el-option v-for="(item, index) in yearList" :key="index" :label="item" :value="item" />
        </el-select>
        <el-select class="m-l-20" filterable v-model="couese" placeholder="请选择辅导课程" clearable>
          <el-option v-for="(item, index) in coueseList" :key="index" :label="item.courseName" :value="item.courseId" />
        </el-select>
      </div>
      <el-input type="textarea" :rows="4" maxlength="200" show-word-limit placeholder="请输入内容..."
        v-model="fromData.content">
      </el-input>
      <div style="display: flex;justify-content: flex-end;">
        <div class="keep-learn keep-check" @click.stop="send()">确认提交</div>
      </div>

    </div>
    <!-- <div class="soreList">
      <div class="sore-item" v-for="(item, index) in list" :key="index">
        <img class="userImg" :src="item.studentPortrait" />
        <div class="sore-content">
          <div class="flex-between-c">
            <div class="userName">{{ item.studentName }}</div>
          </div>
          <div class="addTime">{{ item.createTime }}</div>
          <div class="content">{{ item.evaluateContent }}</div>
          <div class="kcName">
            {{ showTypeEnum[item.courseType] }} · {{ item.courseName }}
          </div>
        </div>
      </div>
    </div> -->
    <!-- <div class="nothing" v-if="!list || list.length == 0">
      <div class="nothing-text">暂无内容哦~</div>
    </div>
    <el-pagination
      class="pagination"
      :total="total"
      :current-page="pageNum"
      :page-sizes="[8, 16, 24, 40]"
      :page-size="pageSize"
      :pager-count="5"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
      background
      layout="total, sizes, prev, pager, next"
    >
    </el-pagination> -->
  </div>
</template>
<script>
import Vue from "vue"
import { getInfo, getToken } from "@/api/cookies"
// import { Evaluation } from '@/api/scoreEvaluation'
// const evaluation = new Evaluation()
import { showTypeEnum } from "@/api/emun"
import { HomeClient } from "@/api/home"
import { debounce } from "@/utils/public"
const homeClient = new HomeClient();
export default {
  data() {
    return {
      showTypeEnum: showTypeEnum,
      pageSize: 8,
      pageNum: 1,
      total: 0,
      list: [],
      userInfo: null,
      kcId: null,
      kcList: null,
      yeaster: null,
      yearList: [],
      couese: null,
      canClick: true,
      coueseList: [],
      fromData: {
        content: "",
        score: 5,
      },
    };
  },
  props: {

    typeId: {
      type: String | Number,
    },
    // 是否购买
    IsPurchase: {
      type: Boolean,
      default: false,
    },
    // 评价类型 1：课程 2：直播
    type: {
      type: Number,
      default: 1,
    },
  },
  created() {
    this.userInfo = getInfo();
    this.getList();

    this.getyears();
  },
  methods: {
    getList() {
      homeClient
        .queryClassEvaluate({
          pageSize: this.pageSize,
          pageNum: this.pageNum,
          coachClassTypeId: this.typeId,
        })
        .then((res) => {
          this.list = res.data.rows;
          this.total = res.data.total;
        });
    },
    async getyears() {
      if (!this.typeId) {
        return;
      }
      await homeClient.getQueryCourseDate(this.typeId).then((res) => {
        if (res.code == 0) {
          this.kcList = res.data;
        }
      });
      this.$forceUpdate();
    },
    async getclass() {
      this.couese = null;
      this.coueseList = [];
      homeClient
        .queryTutorialCourse({
          coachClassTypeId: this.typeId,
          belongCourseTitleId: this.kcId,
          yearDate: this.yeaster,
        })
        .then((res) => {
          this.coueseList = res.data;
        });
    },
    /* 选择课程名 */
    kcChange() {
      this.coueseList = [];
      this.yearList = [];
      this.yeaster = null;
      this.couese = null;
      if (this.kcId) {
        this.getclass();
      }
      for (let item of this.kcList) {
        if (item.belongCourseTitleId == this.kcId) {
          this.yearList = item.yearDate;
          return;
        }
      }
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getList();
    },

    send: debounce(function() {
      if (!this.canClick) {
        return;
      }
      this.canClick = false;
      let userInfo = getInfo();

      if (!userInfo) {
        Vue.prototype.goLoginView(false);
        this.canClick = true;
        return;
      }
      if (!this.IsPurchase) {
        this.$notify({
          title: '提示', 
          message: '您还没有购买!',
          type: 'warning'
        });
        return;
      }
      if (!this.fromData.content) {
        this.$message({
          showClose: true,
          message: "提交内容不能为空!",
          type: "warning",
        });
        this.canClick = true;
        return;
      }

      if (!this.couese && this.type != 2) {
        this.$message({
          showClose: true,
          message: "尚未选择课程，无法评价",
          type: "warning",
        });

        return;
      }

      this.$nextTick(() => {
        homeClient
          .addClassEvaluate({
            courseId:this.type==2?this.typeId:this.couese,
            evaluateContent: this.fromData.content,
            studentId: userInfo.userId,
          })
          .then((res) => {
            if (res.code == 0) {
              this.getList();
            }
          });
      });
      this.canClick = true;
    }, 300),
  },
};
</script>

<style lang="less" scoped>
/* 提价 */
.scoreEvaluation {
  padding: 32px;
}

/* 内容 */
.soreList {
  width: 100%;
  margin-top: 26px;

  .sore-item {
    width: 100%;
    display: flex;
    padding: 24px 0px 20px;
    border-bottom: 1px solid #eee;

    .userImg {
      width: 48px;
      height: 48px;
      opacity: 1;
      border-radius: 50%;
      margin-right: 16px;
      flex-shrink: 0;
    }

    .sore-content {
      width: 100%;

      .userName {
        font-size: 16px;
        font-family: Microsoft YaHei-Regular;
        font-weight: 400;
        color: #333333;
        line-height: 16px;
        margin-top: 5px;
      }

      .addTime {
        font-size: 14px;
        font-family: Microsoft YaHei-Regular;
        font-weight: 400;
        color: #999999;
        line-height: 14px;
        margin-top: 8px;
      }

      .content {
        font-size: 16px;
        font-family: Microsoft YaHei-Regular;
        font-weight: 400;
        color: #666666;
        line-height: 18px;
        margin-top: 21px;
      }

      .kcName {
        margin-top: 20px;
        height: 24px;
        background: #f5f7f9;
        border-radius: 4px 4px 4px 4px;
        opacity: 1;
        font-size: 12px;
        font-family: Microsoft YaHei-Regular, Microsoft YaHei;
        font-weight: 400;
        color: #999999;
        line-height: 24px;
        padding: 0px 8px;
        display: inline-block;
      }
    }
  }
}

/deep/.el-select {
  .el-input__inner,
  input {
    height: 32px !important;
  }

  .el-input__icon {
    line-height: 32px;
  }
}

.rate {
  display: flex;
  justify-content: center;
}

.answer-img {
  position: fixed;
  bottom: 200px;
  right: 16px;

  image {
    width: 48px;
    height: 48px;
  }
}

.coupon-content {
  .coupon-title {
    margin: 0px 0px 26px;
    display: flex;
    align-items: center;

    .rate {
      margin-left: 12px;

      /deep/ .el-rate {
        height: 100%;

        .el-rate__icon {
          font-size: 22px;
        }
      }
    }
  }

  .keep-learn {
    height: 40px;
    line-height: 38px;
    padding: 0px 28px;
    margin: 24px 0px 0px;
    ;
    // float: right;
  }
}

.pagination {
  margin: 20px auto 0px;
}
</style>
